module.exports = __webpack_public_path__ + "static/media/England_France.0a92e50a.jpeg";